import { createContext, useContext, useMemo } from "react";
import PropTypes from "prop-types";
import { useQuery } from "react-query";

import Loader from "../../components/Loader";
import { pageContent } from "../services/eqqo.page.content";
import { useUser } from "../UserContext";

const ReportContext = createContext(null);

const ReportProvider = ({ children }) => {
	const { eqqoOptions } = useUser();

	const {
		data: reportContent,
		isLoading
	} = pageContent( eqqoOptions?.report_content, useQuery, { enabled: !!eqqoOptions?.report_content });

	const reportData = useMemo(() => ({
		reportContent
	}), [reportContent]);


	return (
		<ReportContext.Provider value={reportData}>
			{isLoading || !reportContent
				? <Loader />
				: children}
		</ReportContext.Provider>
	);
}

ReportProvider.propTypes = {
	children: PropTypes.node.isRequired
};

export default ReportProvider;

export const useReport = () => useContext(ReportContext);